export const S1col1 = [
  {
    id: 1,
    question: "Who can avail IZB-SMS facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 2,
    question: "How do I register for the facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 3,
    question:
      "Can I have more than 2 deposit accounts linked for the facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 4,
    question: "What is the benefit to me from SMS Banking?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 5,
    question: "Can I use my existing mobile phone to receive alert messages?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
];
export const S1col2 = [
  {
    id: 6,
    question: "Are there any charges from Bank?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 7,
    question:
      "Can I change my mobile Number and still continue to avail the service?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 8,
    question: "What if my account is a Joint account?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 9,
    question: "Can I terminate this service?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 10,
    question: "Can I register my Loan Account for this facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
];

export const S2col1 = [
  {
    id: 1,
    question: "Who can avail E-Statement facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 2,
    question: "How do I register for the facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 3,
    question:
      "Can I have more than 2 deposit accounts linked for the facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 4,
    question: "What is the benefit to me from E-Statement?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 5,
    question: "Are there any charges from Bank?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
];
export const S2col2 = [
  {
    id: 6,
    question:
      "Can I change my mobile Number and still continue to avail the service?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 7,
    question: "What if my account is a Joint account?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 8,
    question: "Can I terminate this service?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
  {
    id: 9,
    question: "Can I register my Loan Account for this facility?",
    answer:
      "All customers of Bank having Savings & Current A/c may avail this facility who are holding a mobile phone. The mobile phone should be in the Account holder’s name.",
  },
];
